const normalizeText = (value) => String(value || '').trim().toLowerCase();

export const toManualExecutionDisplayStatus = (result) => {
  const status = normalizeText(result?.status);
  const detail = normalizeText(result?.detail);

  if (status === 'manual' || status === 'manual_pending') {
    if (detail.includes(':mark')) return 'manual_mark';
    return 'manual_send';
  }

  return status || 'manual_send';
};
